import { SetStateAction, Dispatch } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material'

import { IStepAccountRespDto } from 'src/types'

import { useMe } from 'src/hooks'
import { HelperWrapper } from 'src/components/helper-wrapper'
import TableListItem from './table-list-item.component'

interface ITableListProps {
  items: IStepAccountRespDto[]
  sort: string
  setSort: Dispatch<SetStateAction<string>>
}

const TableList = ({ items, sort, setSort }: ITableListProps) => {
  const { data: user } = useMe()

  const handleSortChange = (sortName: string) => () => {
    setSort((prevSort) =>
      prevSort.split('-')[1] === 'asc' ? `${sortName}-desc` : `${sortName}-asc`,
    )
  }

  const sortActive = sort.split('-')[0]
  const sortDirection = sort.split('-')[1] as 'desc' | 'asc'

  return (
    <TableContainer sx={{ minWidth: '660px' }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              <TableSortLabel
                onClick={handleSortChange('step.account.account_holder')}
                active={sortActive === 'step.account.account_holder'}
                direction={sortDirection}
                sx={{
                  marginLeft: '20px',
                }}
              >
                <HelperWrapper t="table-account-column" />
              </TableSortLabel>
            </TableCell>
            <TableCell align="center">
              <TableSortLabel
                onClick={handleSortChange('step.name')}
                active={sortActive === 'step.name'}
                direction={sortDirection}
                sx={{
                  marginLeft: '20px',
                }}
              >
                <HelperWrapper t="steps-table-name-column" />
              </TableSortLabel>
            </TableCell>
            <TableCell align="center">
              {/* <TableSortLabel
                onClick={handleSortChange('step.location_name')}
                active={sortActive === 'step.location_name'}
                direction={sortDirection}
                sx={{
                  marginLeft: '20px',
                }}
              > */}
              <HelperWrapper t="steps-table-location-column" />
              {/* </TableSortLabel> */}
            </TableCell>
            <TableCell align="center">
              <TableSortLabel
                onClick={handleSortChange('connection.account_approved')}
                active={sortActive === 'connection.account_approved'}
                direction={sortDirection}
                sx={{
                  marginLeft: '20px',
                }}
              >
                <HelperWrapper t="account-users-status-column" />
              </TableSortLabel>
            </TableCell>
            <TableCell align="center">
              <TableSortLabel
                onClick={handleSortChange('connection.account_disconnected')}
                active={sortActive === 'connection.account_disconnected'}
                direction={sortDirection}
                sx={{
                  marginLeft: '20px',
                }}
              >
                <HelperWrapper t="account-users-actions-column" />
              </TableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items?.map((row) => (
            <TableListItem key={row.id} item={row} userTimezone={user?.timezone} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export { TableList }
